import { render, staticRenderFns } from "./smartattendancefield.vue?vue&type=template&id=6490326b&scoped=true"
import script from "./smartattendancefield.vue?vue&type=script&lang=js"
export * from "./smartattendancefield.vue?vue&type=script&lang=js"
import style0 from "./smartattendancefield.vue?vue&type=style&index=0&id=6490326b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490326b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
